import React, {useEffect, useState} from "react"
import ActivityList from "../../components/activity";
import { getActivitiesVisible } from "../../service";
import {ActivitiesData} from "../types";
import Pagination from "../../components/pagination";
import usePagination from "../../routers/usePagination";
import {useLoading} from "../../components/loading/LoadingProvider";

type Activities = Array<ActivitiesData>

function Activity() {

    const [nowLists,setNowLists] = useState<Activities>([])
    const [pageNum,setPage] = useState<number>(1);
    const { pageRef,noMore } = usePagination()
    const loading = useLoading()

    useEffect(() => {
        if(pageNum === 1){
            loading.showLoading()
        }
        getActivitiesVisible({
            pageNum,
        }).then(res => {
            if(res.code === 1){
                loading.hideLoading()
                const lists = res.data.list
                if((lists as Array<Activities>).length > 0){
                    setNowLists(list => list.concat(lists))
                }else{
                    noMore()
                }
            }else{
                loading.showError('无法获取数据')
            }
        })
    },[pageNum])

    return <div className="activity">
        <ActivityList lists={ nowLists }/>
        <Pagination ref={pageRef} length={nowLists.length} onChange={ (n) => setPage(n) }/>
    </div>
}

export default Activity;
